import React from 'react';
import {
  Step,
  StepNumber,
  StepContent,
  StepContentTitle,
  StepContentText,
  StepContentSmallText,
  Image
} from 'products/nomad_insurance/views/Profile/ClaimsOld/styled';
import stepFourImage from 'products/nomad_insurance/assets/img/claims/step-four-copy.svg';

const StepFour = () => {
  return (
    <Step>
      <StepNumber>
        <span>4</span>
      </StepNumber>
      <StepContent>
        <Image>
          <img src={stepFourImage} alt="Illustration of reimbursement" />
        </Image>
        <StepContentTitle>Get reimbursed</StepContentTitle>
        <StepContentText>
          If approved, you will receive the reimbursement into your bank account by a wire
          transfer.*
        </StepContentText>
        <StepContentSmallText>
          *If your claim is less than the USD $250 deductible and this is your first
          claim, your refund will be substracted from your deductible and there will not
          be a reimbursement until your total claim amount for the certificate period (max
          364 days) is more than $250.
        </StepContentSmallText>
      </StepContent>
    </Step>
  );
};

export default StepFour;
